/* Wallcore · page produit : galerie, version (variante) sur place, options (prix recalculé côté client), avis, reels, barre collante */
(function () {
  // la balise est dans les deux sections produit : la seconde execution ne refait rien (la premiere initialise tout)
  if (window.WallcoreProduct) return;
  var isMobile = function () { return window.matchMedia('(max-width: 1024px) and (pointer: coarse)').matches; };

  // L'ebook est offert avec la Station Pro : des que la Pro entre au panier,
  // la version payante a 19 EUR en sort, meme si elle avait ete ajoutee avant.
  function ebookId(which) {
    var el = document.querySelector('[data-wc-ebook]');
    var id = el && el.dataset[which] ? Number(el.dataset[which]) : 0;
    return id || 0;
  }
  // la Pro emporte l'ebook offert avec elle, depuis n'importe quel bouton de la page.
  // L'ebook ne va plus au panier en ligne a 0 EUR : Shopify envoyait alors un ajout au panier par ligne,
  // et Meta comptait deux ajouts pour un clic. Il suit la ligne de la Pro en propriete (visible au paiement
  // et dans la commande), le panier l'affiche en ligne offerte et l'email de confirmation donne le lien.
  var GIFT_PROP = 'Ebook d’entraînement';
  function withGift(items) {
    var pro = proIds();
    if (!items.some(function (it) { return pro.indexOf(Number(it.id)) !== -1; })) return items;
    var free = ebookId('free');
    return items.filter(function (it) { return !free || Number(it.id) !== free; }).map(function (it) {
      if (pro.indexOf(Number(it.id)) === -1) return it;
      var props = {};
      for (var k in (it.properties || {})) props[k] = it.properties[k];
      props[GIFT_PROP] = 'offert';
      return { id: it.id, quantity: it.quantity, properties: props };
    });
  }
  function proIds() {
    var tag = document.querySelector('[data-wc-variants]');
    if (!tag) return [];
    var pro = [];
    try {
      JSON.parse(tag.textContent).forEach(function (v) { if (v.pro) pro.push(Number(v.id)); });
    } catch (e) { return []; }
    return pro;
  }
  function isProItem(items) {
    var pro = proIds();
    return items.some(function (it) { return pro.indexOf(Number(it.id)) !== -1; });
  }
  function dropPaidEbook(items, addUrl) {
    var paid = ebookId('paid');
    if (!paid || !isProItem(items)) return Promise.resolve();
    var updates = {};
    updates[paid] = 0;
    return fetch(addUrl.replace(/\/add$/, '/update') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .catch(function () {});
  }

  function addToCart(btn, items, addUrl, cartUrl, err) {
    items = withGift(items);
    // test A/B des pages d'arrivee : la version vue suit la ligne jusque dans la commande (propriete cachee)
    if (window.WC_AB) items = items.map(function (it) {
      var props = {};
      for (var k in (it.properties || {})) props[k] = it.properties[k];
      props._ab = window.WC_AB;
      return { id: it.id, quantity: it.quantity, properties: props };
    });
    var label = btn.textContent;
    btn.dataset.wcLabel = btn.innerHTML;
    btn.disabled = true; btn.textContent = 'Ajout en cours';
    if (err) err.style.display = 'none';
    // l'ebook payant ne sort du panier que s'il y est : la lecture du panier part en meme temps que l'ajout,
    // ce qui evite un aller-retour de plus (500 ms en 4G) dans le cas courant ou il n'y est pas
    var paid = ebookId('paid');
    var hasPaid = (paid && isProItem(items))
      ? fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { return (c.items || []).some(function (it) { return Number(it.variant_id) === paid; }); })
          .catch(function () { return true; })
      : Promise.resolve(false);
    fetch(addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return hasPaid; })
      .then(function (drop) { return drop ? dropPaidEbook(items, addUrl) : null; })
      .then(function () { window.location.href = cartUrl; })
      .catch(function () { btn.disabled = false; btn.textContent = label; delete btn.dataset.wcLabel; if (err) err.style.display = 'block'; });
  }
  // retour arriere depuis le panier : le navigateur rend la page telle quelle, bouton bloque compris
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-wc-label]').forEach(function (b) { b.innerHTML = b.dataset.wcLabel; b.disabled = false; delete b.dataset.wcLabel; });
  });

  // Carrousel a boucle infinie : on cadre trois jeux de cartes identiques et on
  // recale la position au repos, le contenu se repetant le saut ne se voit pas.
  function loopTrack(track) {
    var items = Array.prototype.slice.call(track.children);
    var n = items.length;
    if (n < 2) return;
    var head = document.createDocumentFragment(), tail = document.createDocumentFragment();
    items.forEach(function (it) {
      var a = it.cloneNode(true); a.setAttribute('aria-hidden', 'true'); head.appendChild(a);
      var b = it.cloneNode(true); b.setAttribute('aria-hidden', 'true'); tail.appendChild(b);
    });
    track.appendChild(tail);
    track.insertBefore(head, items[0]);

    // une seule lecture de mise en page : les positions sont mises en cache, le defilement ne relit plus le DOM
    // (chaque offsetLeft lu apres une ecriture force une mise en page complete de la page)
    var kids = Array.prototype.slice.call(track.children);
    var lefts = [], setW = 0;
    var measure = function () {
      var base = kids[0].offsetLeft;
      lefts = kids.map(function (el) { return el.offsetLeft - base; });
      setW = lefts[n];
    };
    measure();
    if (!setW) return;
    var rel = function (el) { return lefts[kids.indexOf(el)] || 0; };

    var dots = document.createElement('div');
    dots.className = 'ws-dots';
    var mark = function (i) {
      Array.prototype.forEach.call(dots.children, function (d, k) {
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    };
    var goTo = function (i) {
      var x = rel(kids[n + i]);
      if (track.scrollTo) track.scrollTo({ left: x, behavior: 'smooth' }); else track.scrollLeft = x;
    };
    for (var i = 0; i < n; i++) {
      var d = document.createElement('button');
      d.type = 'button'; d.className = 'ws-dot'; d.setAttribute('aria-label', 'Carte ' + (i + 1));
      (function (k) { d.addEventListener('click', function () { goTo(k); }); })(i);
      dots.appendChild(d);
    }
    track.parentNode.insertBefore(dots, track.nextSibling);

    track.scrollLeft = setW;
    mark(0);

    var tid = null;
    track.addEventListener('scroll', function () {
      var x = track.scrollLeft, best = 0, bd = Infinity;
      lefts.forEach(function (l, k) { var d = Math.abs(l - x); if (d < bd) { bd = d; best = k; } });
      mark(best % n);
      clearTimeout(tid);
      tid = setTimeout(function () {
        var p = track.scrollLeft;
        if (p < setW * 0.5) track.scrollLeft = p + setW;
        else if (p > setW * 1.5) track.scrollLeft = p - setW;
      }, 140);
    }, { passive: true });
    var rid = null;
    window.addEventListener('resize', function () { clearTimeout(rid); rid = setTimeout(function () { measure(); if (setW) track.scrollLeft = setW; }, 200); });
  }

  /* ---------- Zone d'achat ---------- */
  window.WallcoreProduct = function (root) {
    if (!root || root.dataset.wcInit) return;
    root.dataset.wcInit = '1';
    var addUrl = root.dataset.addUrl, cartUrl = root.dataset.cartUrl;

    // Galerie : les photos suivent la version choisie. Les vignettes des deux versions sont dans la page
    // (data-wc-set="station" / "pro"), celles de l'autre version sont masquees en CSS par data-version.
    var mainImg = root.querySelector('.wc-main-panel img');
    var mainWrap = root.querySelector('[data-wc-main]');
    var counter = root.querySelector('[data-wc-counter]'), countAll = root.querySelector('[data-wc-count]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-wc-thumb]'));
    var shownThumbs = function () {
      var ver = root.getAttribute('data-version');
      return thumbs.filter(function (t) { var s = t.dataset.wcSet; return !s || s === 'all' || s === ver; });
    };
    // Prechargement : sans lui chaque passage attend le reseau (0,8 a 1,4 s en 4G) et l'ancienne photo reste
    // affichee pendant ce temps, le tap semble ignore. Memes sizes et srcset que la grande image : le navigateur
    // choisit le meme fichier, le passage le trouve en cache.
    var warmed = {};
    var warm = function (t) {
      if (!t || !mainImg || warmed[t.dataset.src]) return;
      warmed[t.dataset.src] = 1;
      var im = new Image();
      im.fetchPriority = 'low';
      im.sizes = mainImg.sizes;
      im.srcset = t.dataset.srcset || '';
      im.src = t.dataset.src;
    };
    // les deux voisines de la photo affichee, dans la version choisie (pas plus : la page pese deja lourd sur telephone)
    var warmAround = function () {
      var list = shownThumbs(), n = list.length;
      if (n < 2) return;
      var cur = 0;
      list.forEach(function (t, i) { if (t.getAttribute('aria-current') === 'true') cur = i; });
      warm(list[(cur + 1) % n]); warm(list[(cur - 1 + n) % n]);
    };
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (o) { o.removeAttribute('aria-current'); });
        t.setAttribute('aria-current', 'true');
        // srcset avant src : le navigateur choisit la taille d'apres sizes, le telephone ne prend pas la 1400 px
        if (mainImg) { mainImg.srcset = t.dataset.srcset || ''; mainImg.src = t.dataset.src; mainImg.alt = t.dataset.alt || ''; }
        if (counter) counter.textContent = String(shownThumbs().indexOf(t) + 1);
        warmAround();
      });
      t.addEventListener('pointerenter', function () { warm(t); }, { passive: true });
    });
    // apres le chargement de la page (rien ne passe devant la premiere photo) : la suivante, et la premiere
    // de l'autre version pour que le choix Station / Pro change aussi la photo sans attendre
    var warmIdle = function () {
      (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(function () {
        var list = shownThumbs(), ver = root.getAttribute('data-version');
        if (list.length > 1) warm(list[1]);
        warm(thumbs.filter(function (t) { var s = t.dataset.wcSet; return s && s !== 'all' && s !== ver; })[0]);
      });
    };
    if (document.readyState === 'complete') warmIdle(); else window.addEventListener('load', warmIdle);
    var galArrows = Array.prototype.slice.call(root.querySelectorAll('[data-wc-gal-step]'));
    // changement de version : premiere photo de la version choisie, avec un court fondu
    var gallerySet = root.getAttribute('data-version');
    var showSet = function () {
      var ver = root.getAttribute('data-version');
      if (ver === gallerySet) return;
      gallerySet = ver;
      var list = shownThumbs();
      if (!list.length) return;
      list[0].click();
      if (countAll) countAll.textContent = String(list.length);
      if (list[0].parentNode) list[0].parentNode.scrollLeft = 0;
      if (mainImg && mainImg.animate) mainImg.animate([{ opacity: 0.3 }, { opacity: 1 }], { duration: 300, easing: 'ease-out' });
      var stickyImg = root.querySelector('.wc-sticky-thumb img'), firstImg = list[0].querySelector('img');
      if (stickyImg && firstImg) { stickyImg.srcset = ''; stickyImg.src = firstImg.src; }
      galArrows.forEach(function (a) { a.hidden = list.length < 2; });
    };
    // photo suivante / precedente dans la version choisie (fleches et glisser du doigt) ;
    // la bande de vignettes defile seule a l'horizontale, la page ne saute pas
    var stepGallery = function (dir) {
      var list = shownThumbs();
      if (list.length < 2) return;
      var cur = 0;
      list.forEach(function (t, i) { if (t.getAttribute('aria-current') === 'true') cur = i; });
      var t = list[((cur + dir) % list.length + list.length) % list.length];
      t.click();
      var strip = t.parentNode;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        var x = t.offsetLeft - strip.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
        if (strip.scrollTo) strip.scrollTo({ left: x, behavior: 'smooth' }); else strip.scrollLeft = x;
      }
    };
    galArrows.forEach(function (a) { a.addEventListener('click', function () { stepGallery(Number(a.dataset.wcGalStep)); }); });
    if (mainWrap && thumbs.length > 1) {
      var gx = null, gy = null;
      mainWrap.addEventListener('touchstart', function (e) { gx = e.touches[0].clientX; gy = e.touches[0].clientY; }, { passive: true });
      mainWrap.addEventListener('touchend', function (e) { if (gx === null) return; var dx = e.changedTouches[0].clientX - gx, dy = e.changedTouches[0].clientY - gy; gx = gy = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) stepGallery(dx < 0 ? 1 : -1); }, { passive: true });
    }

    // Prix : variante + options cochées (centimes), au format monétaire de la boutique
    var moneyFormat = root.dataset.moneyFormat || '{{amount}}';
    var fmt = function (cents) {
      var v = cents / 100;
      var num = function (dec, thou, decsep) { var p = v.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou); return p.length > 1 ? p[0] + decsep + p[1] : p[0]; };
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
        if (k === 'amount_no_decimals') return num(0, ',', '');
        if (k === 'amount_with_comma_separator') return num(2, '.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return num(0, '.', '');
        if (k === 'amount_with_space_separator') return num(2, ' ', ',');
        if (k === 'amount_no_decimals_with_space_separator') return num(0, ' ', '');
        if (k === 'amount_with_apostrophe_separator') return num(2, "'", '.');
        if (k === 'amount_with_period_and_space_separator') return num(2, ' ', '.');
        return num(2, ',', '.');
      });
    };
    var addons = Array.prototype.slice.call(root.querySelectorAll('[data-wc-addon]'));
    var total = root.querySelector('[data-wc-total]');
    var proEffect = root.dataset.proEffect !== '0';
    // le prix defile d'un montant a l'autre
    var rollFrom = null, rollId = null;
    function setTotal(cents) {
      if (!total) return;
      var from = rollFrom;
      rollFrom = cents;
      if (!proEffect || from === null || from === cents || !window.requestAnimationFrame) { total.textContent = fmt(cents); return; }
      var t0 = (window.performance && performance.now) ? performance.now() : Date.now(), dur = 450;
      if (rollId) cancelAnimationFrame(rollId);
      var step = function (t) {
        var k = Math.min(1, ((t || Date.now()) - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        total.textContent = fmt(Math.round(from + (cents - from) * e));
        if (k < 1) rollId = requestAnimationFrame(step);
      };
      rollId = requestAnimationFrame(step);
    }
    // coup de projecteur au passage sur la Pro
    var boostId = null;
    function boost() {
      if (!proEffect) return;
      root.removeAttribute('data-boost');
      void root.offsetWidth;
      root.setAttribute('data-boost', '');
      clearTimeout(boostId);
      boostId = setTimeout(function () { root.removeAttribute('data-boost'); }, 1200);
    }
    var note = root.querySelector('[data-wc-note]');
    var stickySub = root.querySelector('[data-wc-sticky-sub]');
    var was = root.querySelector('[data-wc-was]');
    var promo = root.querySelector('[data-wc-promo]'), promoOff = root.querySelector('[data-wc-promo-off]');
    var split = root.querySelector('[data-wc-split]');
    function refresh() {
      var sum = Number(total && total.dataset.base) || 0, names = [];
      addons.forEach(function (cb) {
        if (!cb.checked || cb.disabled) return;
        var p = Number(cb.dataset.price) || 0;
        sum += p;
        if (p > 0 && cb.dataset.short) names.push(cb.dataset.short);
      });
      setTotal(sum);
      var base = Number(total && total.dataset.base) || 0, cmp = Number(total && total.dataset.compare) || 0;
      var wasSum = cmp > base ? sum - base + cmp : 0;
      if (was) { if (wasSum) { was.textContent = fmt(wasSum); was.hidden = false; } else { was.hidden = true; } }
      if (promo) { promo.hidden = !(cmp > base); if (promoOff && cmp > base) promoOff.textContent = '-' + fmt(cmp - base).replace(/[.,]00(?=\D*$)/, ''); }
      if (note) note.textContent = names.length ? note.dataset.withAddons : note.dataset.base;
      if (split) { var third = fmt(Math.ceil(sum / 3)).replace(/[.,]00(?=\D*$)/, ''), amt = split.querySelector('[data-wc-split-amt]'); if (amt) amt.innerHTML = 'ou <b>3 x ' + third + '</b>'; else split.textContent = split.dataset.tpl.replace('[montant]', third); }
      if (stickySub) {
        // prix sans les ,00 pour tenir sur une ligne de téléphone ; barré si la version a un prix avant réduction
        var short = function (c) { return fmt(c).replace(/[.,]00(?=\D*$)/, ''); };
        stickySub.textContent = (names.length ? stickySub.dataset.name + ' + ' + names.join(' + ') : stickySub.dataset.base) + ' · ';
        if (wasSum) { var s = document.createElement('s'); s.textContent = short(wasSum); stickySub.appendChild(s); }
        stickySub.appendChild(document.createTextNode(short(sum)));
      }
      var picked = [];
      addons.forEach(function (cb) { if (cb.checked && cb.dataset.product) picked.push(String(cb.dataset.product)); });
      document.dispatchEvent(new CustomEvent('wc:addons', { detail: { products: picked } }));
    }
    addons.forEach(function (cb) {
      cb.addEventListener('click', function (e) { if (cb.hasAttribute('data-locked')) e.preventDefault(); });
      cb.addEventListener('change', refresh);
    });
    refresh();

    // Ajout au panier (bouton principal + barre collante)
    var err = root.querySelector('[data-wc-error]');
    root.querySelectorAll('[data-wc-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var items = [{ id: Number(btn.dataset.variant), quantity: 1 }];
        root.querySelectorAll('[data-wc-addon]').forEach(function (cb) {
          if (cb.checked && !cb.disabled && cb.value) items.push({ id: Number(cb.value), quantity: 1 });
        });
        addToCart(btn, items, addUrl, cartUrl, err);
      });
    });

    // Barre collante
    var sticky = root.querySelector('[data-wc-sticky]');
    var buy = root.querySelector('[data-wc-buy]');
    if (sticky && buy && 'IntersectionObserver' in window) {
      // visible quand le bouton principal n'est pas à l'écran ET qu'on a quitté la grande photo
      // (sur téléphone, 7 visiteurs sur 10 repartaient avant d'atteindre le bouton)
      var buyIn = true, buyAbove = false, photoGone = false;
      var paint = function () { if (!buyIn && (buyAbove || photoGone)) sticky.setAttribute('data-on', ''); else sticky.removeAttribute('data-on'); };
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        buyIn = e.isIntersecting; buyAbove = !e.isIntersecting && e.boundingClientRect.top < 0; paint();
      }, { threshold: 0 }).observe(buy);
      var photo = root.querySelector('.wc-main-panel');
      if (photo) new IntersectionObserver(function (entries) {
        var e = entries[0];
        photoGone = e.boundingClientRect.top < 0 && e.intersectionRatio < 0.35; paint();
      }, { threshold: [0, 0.35, 0.7, 1] }).observe(photo);
    }

    // Depliants : dimensions, livraison, montage, garantie
    root.querySelectorAll('[data-wc-acci]').forEach(function (h) {
      h.addEventListener('click', function () {
        h.setAttribute('aria-expanded', h.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      });
    });

    // Avis : carrousel par page
    var rv = root.querySelector('[data-wc-reviews]');
    if (rv) {
      var cards = Array.prototype.slice.call(rv.querySelectorAll('[data-wc-rev]'));
      var prev = rv.querySelector('[data-wc-rev-prev]'), next = rv.querySelector('[data-wc-rev-next]');
      var dots = rv.querySelector('[data-wc-rev-dots]');
      var page = 0;
      var per = function () { return isMobile() ? Number(rv.dataset.perMobile) : Number(rv.dataset.per); };
      var pageCount = function () { return Math.max(1, Math.ceil(cards.length / per())); };
      // dir : 1 = vers la droite (suivant), -1 = vers la gauche ; les avis entrent alors par le cote
      var render = function (dir) {
        var p = per(), pages = pageCount();
        if (page > pages - 1) page = pages - 1;
        cards.forEach(function (c, i) { c.hidden = !(i >= page * p && i < page * p + p); });
        if (dir && cards[0].animate) {
          cards.forEach(function (c) {
            if (!c.hidden) c.animate([{ transform: 'translateX(' + (dir * 36) + 'px)', opacity: 0 }, { transform: 'translateX(0)', opacity: 1 }], { duration: 260, easing: 'cubic-bezier(.2, .7, .3, 1)' });
          });
        }
        if (prev) prev.disabled = page === 0;
        if (next) next.disabled = page >= pages - 1;
        if (dots) {
          dots.innerHTML = '';
          for (var i = 0; i < pages; i++) {
            var d = document.createElement('button'); d.type = 'button'; d.className = 'wc-dot'; d.setAttribute('aria-label', 'Page ' + (i + 1));
            if (i === page) d.setAttribute('aria-current', 'true');
            (function (k) { d.addEventListener('click', function () { if (k === page) return; var dd = k > page ? 1 : -1; page = k; render(dd); }); })(i);
            dots.appendChild(d);
          }
        }
      };
      if (prev) prev.addEventListener('click', function () { if (page > 0) { page--; render(-1); } });
      if (next) next.addEventListener('click', function () { if (page < pageCount() - 1) { page++; render(1); } });
      window.addEventListener('resize', function () { render(); });
      render();

      // glisser le doigt : l'avis suit le doigt, puis passe au suivant (ou au precedent), sinon revient en place
      var drag = null;
      var settle = function (list, animate) {
        list.forEach(function (c) {
          c.style.transition = animate ? 'transform .25s ease, opacity .25s ease' : '';
          c.style.transform = ''; c.style.opacity = '';
        });
        if (animate) setTimeout(function () { list.forEach(function (c) { c.style.transition = ''; }); }, 260);
      };
      rv.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1 || (e.target.closest && e.target.closest('button'))) { drag = null; return; }
        drag = { x: e.touches[0].clientX, y: e.touches[0].clientY, dx: 0, axis: '', list: cards.filter(function (c) { return !c.hidden; }) };
      }, { passive: true });
      rv.addEventListener('touchmove', function (e) {
        if (!drag) return;
        var mx = e.touches[0].clientX - drag.x, my = e.touches[0].clientY - drag.y;
        if (!drag.axis && (Math.abs(mx) > 8 || Math.abs(my) > 8)) drag.axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (drag.axis !== 'x') return;
        drag.dx = mx;
        // en butee (premier ou dernier avis), l'avis resiste au lieu de suivre le doigt
        var stuck = (mx > 0 && page === 0) || (mx < 0 && page >= pageCount() - 1);
        var shift = stuck ? mx * 0.25 : mx;
        drag.list.forEach(function (c) {
          c.style.transition = 'none';
          c.style.transform = 'translateX(' + shift + 'px)';
          c.style.opacity = String(1 - Math.min(Math.abs(shift) / 500, 0.4));
        });
      }, { passive: true });
      var release = function () {
        if (!drag) return;
        var d = drag; drag = null;
        if (d.axis !== 'x') return;
        var dir = d.dx < 0 ? 1 : -1;
        if (Math.abs(d.dx) > 40 && ((dir > 0 && page < pageCount() - 1) || (dir < 0 && page > 0))) {
          settle(d.list, false);
          page += dir;
          render(dir);
        } else {
          settle(d.list, true);
        }
      };
      rv.addEventListener('touchend', release);
      rv.addEventListener('touchcancel', release);
    }

    // Reels : coverflow, rotation automatique.
    // Rien ne se charge avant que la scene approche de l'ecran : chaque video pese plusieurs Mo (le flux HLS, plus leger,
    // est lu en natif par Safari et Chrome). A l'approche, les affiches sont posees sur les quatre reels mais seuls le reel
    // actif et le suivant commencent a charger ; les autres attendent leur tour. Le reel actif repart toujours de zero,
    // et le passage au suivant est programme a partir du moment ou l'image bouge vraiment, pour la duree du clip (12 s au plus).
    var stage = root.querySelector('[data-wc-reels-stage]');
    if (stage) {
      var reels = Array.prototype.slice.call(stage.querySelectorAll('[data-wc-reel]'));
      var rdots = root.querySelector('[data-wc-reel-dots]');
      var n = reels.length, active = 0, timer = null, guard = null, near = false, armed = false, held = false;
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var CAP = 12;
      var vid = function (r) { return r.querySelector('video'); };
      var cur = function () { return vid(reels[active]); };
      var wrap = function (i) { return ((i % n) + n) % n; };
      var stop = function () { clearTimeout(timer); clearTimeout(guard); timer = guard = null; };
      // Pose une position sans transition (la tuile est invisible a ce moment-la)
      var jump = function (r, pos) { r.classList.add('is-jump'); r.setAttribute('data-pos', pos); void r.offsetWidth; r.classList.remove('is-jump'); };
      var arm = function () {
        if (armed) return; armed = true;
        reels.forEach(function (r) { var v = vid(r); if (v && v.dataset.poster) v.setAttribute('poster', v.dataset.poster); });
      };
      var prime = function (i) { var v = vid(reels[wrap(i)]); if (v && v.preload === 'none') { lowHls(v); v.preload = 'metadata'; } };
      // Positions : 0 au centre, -1 / 1 sur les cotes, -2 / 2 ranges hors champ. Toutes les tuiles bougent dans le sens du
      // defilement (dir = 1 : vers la gauche). Une tuile qui devrait remonter le courant est d'abord posee, sans transition,
      // du cote par lequel elle entre : sinon elle traverse la scene derriere le reel central (c'etait le bug visible).
      var setPos = function (dir) {
        reels.forEach(function (r, i) {
          var d = wrap(i - active); if (d > n / 2 || (d === n / 2 && dir > 0)) d -= n;
          if (n === 2 && d === -1) d = 1;
          var p = Math.max(-2, Math.min(2, d));
          var was = r.getAttribute('data-pos'), o = was === 'x' || was === null ? null : parseInt(was, 10);
          if (!dir || o === null) { jump(r, String(p)); return; }
          if ((dir > 0 && p > o) || (dir < 0 && p < o)) { jump(r, dir > 0 ? '2' : '-2'); if (Math.abs(p) >= 2) return; }
          r.setAttribute('data-pos', String(p));
        });
        if (rdots) Array.prototype.forEach.call(rdots.children, function (d, i) { if (i === active) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      };
      var limOf = function (v) { return Math.min(v.duration && isFinite(v.duration) && v.duration > 0.5 ? v.duration : CAP, CAP); };
      // Le passage au suivant se decide sur l'horloge de la video (timeupdate), pas sur l'horloge murale : un tampon reseau
      // ne rogne plus la fin du clip. Le minuteur ne sert que de filet si l'horloge de la video s'arrete.
      var watch = function (v) {
        stop();
        if (n < 2 || still || held) return;
        timer = setTimeout(function () { if (near && cur() === v) go(active + 1, 1); }, Math.max(600, (limOf(v) - v.currentTime) * 1000 + 2500));
      };
      var last = [];
      var play = function (resume) {
        var v = cur(); if (!v || !near) return;
        // seule l'active est amorcee : chaque flux HLS de Shopify n'a qu'un segment, amorcer le suivant le telechargeait
        // en entier (2 a 4 Mo) meme si personne ne regardait ; il l'est maintenant 1,5 s avant la fin du clip (timeupdate)
        prime(active);
        if (!resume) { last[active] = 0; try { if (v.readyState > 0 && v.currentTime > 0.05) v.currentTime = 0; } catch (e) {} }
        var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
        stop();
        // Garde-fou : si l'image ne bouge pas (lecture bloquee, reseau lent), on passe quand meme au suivant
        if (n > 1 && !still && !held) guard = setTimeout(function () { if (near && cur() === v) go(active + 1, 1); }, 8000);
      };
      var go = function (i, dir) {
        if (!document.body.contains(stage)) { stop(); return; }
        var next = wrap(i);
        if (!dir) { var k = wrap(next - active); dir = k === 0 ? 0 : (k <= n / 2 ? 1 : -1); }
        active = next; held = false; reels[active].removeAttribute('data-held');
        setPos(dir);
        reels.forEach(function (r, j) { var v = vid(r); if (v && j !== active) { if (!v.paused) v.pause(); r.removeAttribute('data-held'); } });
        play(false);
      };
      var wake = function () { if (near) return; near = true; arm(); play(true); };
      var sleep = function () { near = false; stop(); reels.forEach(function (r) { var v = vid(r); if (v && !v.paused) v.pause(); }); };
      reels.forEach(function (r, i) {
        var v = vid(r); if (!v) return;
        v.addEventListener('playing', function () { if (i === active && near) watch(v); });
        v.addEventListener('waiting', function () { if (i === active) { clearTimeout(timer); timer = null; } });
        v.addEventListener('timeupdate', function () {
          if (i !== active || !near || held || n < 2 || still) return;
          var t = v.currentTime;
          if (t >= limOf(v) - 1.5) prime(active + 1);
          if (t >= limOf(v) - 0.25 || (last[i] > 1 && t < last[i] - 1)) { last[i] = 0; go(active + 1, 1); return; }
          last[i] = t;
        });
      });
      if (rdots && n > 1) { reels.forEach(function (_, i) { var d = document.createElement('button'); d.type = 'button'; d.className = 'wc-dot'; d.setAttribute('aria-label', 'Reel ' + (i + 1)); d.addEventListener('click', function () { go(i, 0); }); rdots.appendChild(d); }); }
      // Un reel lateral ramene au centre ; le reel central se met en pause d'une touche, et repart de la meme facon
      reels.forEach(function (r, i) {
        r.addEventListener('click', function () {
          if (i !== active) { go(i, 0); return; }
          var v = vid(r); if (!v) return;
          if (held) { held = false; r.removeAttribute('data-held'); play(true); }
          else { held = true; r.setAttribute('data-held', ''); stop(); if (!v.paused) v.pause(); }
        });
      });
      var x0 = null, y0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = y0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        go(active + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      }, { passive: true });
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else if (near && document.body.contains(stage) && !held) play(true); });
      setPos(0);
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) wake(); else if (near) sleep(); }); }, { rootMargin: '300px 0px' }).observe(stage);
      } else { wake(); }
    }

    // Version : la Station Pro est une variante, le choix se fait sur place
    var vdata = [];
    try { var vs = root.querySelector('[data-wc-variants]'); if (vs) vdata = JSON.parse(vs.textContent); } catch (e) { vdata = []; }
    var vcards = root.querySelectorAll('[data-wc-variant]');
    var title = root.querySelector('[data-wc-title]'), stickyName = root.querySelector('[data-wc-sticky-name]');
    var titlePro = root.querySelector('[data-wc-title-pro]');
    var unlock = root.querySelector('[data-wc-unlock]');
    var ebook = root.querySelector('[data-wc-ebook]');
    var ebookChoice = !!(ebook && ebook.dataset.defaultOn === '1');
    if (ebook) { var ecb = ebook.querySelector('input'); if (ecb) ecb.addEventListener('change', function () { if (!ecb.hasAttribute('data-locked')) ebookChoice = ecb.checked; }); }
    function selectVariant(id) {
      var v = null;
      vdata.forEach(function (x) { if (String(x.id) === String(id)) v = x; });
      if (!v) return;
      vcards.forEach(function (c) { if (c.dataset.wcVariant === String(v.id)) c.setAttribute('aria-current', 'page'); else c.removeAttribute('aria-current'); });
      if (total) { total.dataset.base = String(v.cents); total.dataset.compare = String(v.compare || 0); }
      root.querySelectorAll('[data-wc-add]').forEach(function (b) {
        b.dataset.variant = String(v.id);
        b.disabled = !v.available;
        b.textContent = v.available ? (b.dataset.label || b.textContent) : 'Indisponible';
      });
      // Le suffixe « Pro » du titre n'existe dans le HTML que si la Pro est affichée : sur la page Station, Google et les
      // lecteurs d'écran lisent « Wallcore Station ». Le texte est posé avant l'animation et retiré une fois le repli fini.
      if (titlePro) {
        clearTimeout(titlePro._wcT);
        if (v.pro) {
          titlePro.textContent = titlePro.getAttribute('data-text') || '';
          titlePro.removeAttribute('aria-hidden');
          void titlePro.offsetWidth;
          titlePro.setAttribute('data-on', '');
        } else {
          titlePro.removeAttribute('data-on');
          titlePro.setAttribute('aria-hidden', 'true');
          titlePro._wcT = setTimeout(function () { if (!titlePro.hasAttribute('data-on')) titlePro.textContent = ''; }, 450);
        }
      }
      else if (title && v.name) title.textContent = v.name;
      if (stickyName && v.name) stickyName.textContent = v.name;
      if (unlock) { if (v.pro) unlock.setAttribute('data-on', ''); else unlock.removeAttribute('data-on'); }
      root.setAttribute('data-version', v.pro ? 'pro' : 'station');
      showSet();
      if (v.pro) boost();
      if (ebook) {
        var cb = ebook.querySelector('input'), desc = ebook.querySelector('[data-wc-ebook-desc]'), tag = ebook.querySelector('[data-wc-ebook-tag]');
        if (v.pro) {
          ebook.setAttribute('data-included', '');
          if (cb) { cb.value = ebook.dataset.free; cb.dataset.price = '0'; cb.checked = true; cb.setAttribute('data-locked', ''); }
          if (desc) desc.textContent = ebook.dataset.descPro;
          if (tag) tag.textContent = ebook.dataset.includedLabel;
        } else {
          ebook.removeAttribute('data-included');
          if (cb) { cb.value = ebook.dataset.paid; cb.dataset.price = ebook.dataset.paidPrice; cb.removeAttribute('data-locked'); cb.checked = ebookChoice; }
          if (desc) desc.textContent = ebook.dataset.descStation;
          if (tag) tag.textContent = ebook.dataset.paidLabel;
        }
      }
      refresh();
      if (root.dataset.sameProduct === '1') {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', String(v.id)); window.history.replaceState(window.history.state, '', u.toString()); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('wc:variant', { detail: { id: v.id, pro: v.pro } }));
    }
    vcards.forEach(function (c) { c.addEventListener('click', function () { selectVariant(c.dataset.wcVariant); }); });
    // annonce la version ouverte a l'arrivee pour que les autres sections s'alignent
    setTimeout(function () {
      var initId = null;
      vcards.forEach(function (c) { if (c.getAttribute('aria-current') === 'page') initId = c.dataset.wcVariant; });
      if (!initId) { var b0 = root.querySelector('[data-wc-add]'); if (b0) initId = b0.dataset.variant; }
      var iv = null;
      vdata.forEach(function (x) { if (String(x.id) === String(initId)) iv = x; });
      if (iv) document.dispatchEvent(new CustomEvent('wc:variant', { detail: { id: iv.id, pro: iv.pro } }));
    }, 0);
    document.addEventListener('wc:variant-select', function (e) {
      selectVariant(e.detail.id);
      if (e.detail && e.detail.scroll === false) return;
      var target = root.querySelector('[data-wc-buy]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  };

  /* ---------- Sections sous la zone d'achat ---------- */
  window.WallcoreStory = function (root) {
    if (!root || root.dataset.wcInit) return;
    root.dataset.wcInit = '1';
    var addUrl = root.dataset.addUrl, cartUrl = root.dataset.cartUrl;

    root.querySelectorAll('[data-ws-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var items = btn.dataset.items.split(',').filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
        addToCart(btn, items, addUrl, cartUrl, null);
      });
    });

    // Accessoires (cartes et fenetres) : « Ajouter » envoie la vignette jusqu'a l'icone panier de l'en-tete,
    // qui s'allume et affiche le nouveau total ; « Ajouté » retire l'article, sans animation.
    // L'etat suit le vrai panier (/cart.js) et les options cochees dans la zone d'achat.
    var accBtns = Array.prototype.slice.call(root.querySelectorAll('[data-ws-acc]'));
    var jsonHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    var inCart = {}, picked = [], pending = 0;
    var accVariant = function (b) { return String(b.dataset.items.split(',')[0]); };
    var setAdded = function (b, on) {
      if (on) { b.setAttribute('data-added', ''); b.textContent = b.dataset.addedLabel || 'Ajouté'; }
      else { b.removeAttribute('data-added'); b.textContent = b.dataset.label || 'Ajouter'; }
    };
    var isPicked = function (b) { return !!b.dataset.product && picked.indexOf(String(b.dataset.product)) !== -1; };
    // coche verrouillee dans la zone d'achat (ebook offert avec la Pro) : rien a ajouter ni a retirer
    var lockedBox = function (b) {
      var found = null;
      if (b.dataset.product) document.querySelectorAll('[data-wc-addon][data-product="' + b.dataset.product + '"]').forEach(function (cb) { if (cb.checked && (cb.disabled || cb.hasAttribute('data-locked'))) found = cb; });
      return found;
    };
    var syncAcc = function () {
      accBtns.forEach(function (b) {
        var v = accVariant(b), lock = !inCart[v] && lockedBox(b);
        if (lock) {
          var holder = lock.closest('[data-included-label]');
          b.setAttribute('data-added', ''); b.setAttribute('data-included', ''); b.setAttribute('aria-disabled', 'true');
          b.textContent = (holder && holder.dataset.includedLabel) || 'Inclus';
          return;
        }
        b.removeAttribute('data-included'); b.removeAttribute('aria-disabled');
        setAdded(b, !!inCart[v] || isPicked(b));
      });
    };
    var readCart = function (cart) {
      inCart = {};
      ((cart && cart.items) || []).forEach(function (it) { inCart[String(it.variant_id)] = (inCart[String(it.variant_id)] || 0) + it.quantity; });
    };
    var readPicked = function () {
      picked = [];
      document.querySelectorAll('[data-wc-addon]').forEach(function (cb) { if (cb.checked && cb.dataset.product) picked.push(String(cb.dataset.product)); });
    };
    var loadCart = function () {
      return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (pending) return; readCart(cart); syncAcc(); })
        .catch(function () {});
    };
    // pastille du panier : on passe par le composant d'Horizon (<cart-icon>), sinon on ecrit le chiffre nous-memes
    var setBubble = function (count, animate) {
      document.querySelectorAll('cart-icon').forEach(function (ci) {
        if (typeof ci.renderCartBubble === 'function') { ci.renderCartBubble(count, animate); return; }
        var n = ci.querySelector('.cart-bubble__text-count'), bb = ci.querySelector('.cart-bubble');
        if (n) { n.textContent = count < 100 ? String(count) : ''; n.classList.toggle('hidden', count === 0); }
        if (bb) bb.classList.toggle('visually-hidden', count === 0);
        ci.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      });
    };
    var cartIcon = function () {
      var all = document.querySelectorAll('cart-icon');
      for (var i = 0; i < all.length; i++) { if (all[i].getClientRects().length) return all[i]; }
      return null;
    };
    // l'icone doit etre a l'ecran et non recouverte (une fenetre ouverte la cache : on ne fait pas voler)
    var iconVisible = function (icon) {
      var r = icon.getBoundingClientRect();
      if (r.bottom <= 0 || r.top >= window.innerHeight) return false;
      var el = document.elementFromPoint(r.left + r.width / 2, r.top + r.height / 2);
      return !!el && icon.contains(el);
    };
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // vol en arc : l'horizontale accelere, la verticale ralentit, la vignette retrecit en entrant dans l'icone
    var fly = function (from, icon) {
      return new Promise(function (done) {
        if (reduceMotion || !from || !icon || !document.body.animate || !iconVisible(icon)) { done(); return; }
        var src = from.querySelector('img');
        var a = (src || from).getBoundingClientRect(), t = icon.getBoundingClientRect();
        if (!a.width) { done(); return; }
        var size = Math.round(Math.max(48, Math.min(88, a.width, a.height)));
        var x0 = a.left + a.width / 2 - size / 2, y0 = a.top + a.height / 2 - size / 2;
        var dx = t.left + t.width / 2 - (x0 + size / 2), dy = t.top + t.height / 2 - (y0 + size / 2);
        var outer = document.createElement('div'), mid = document.createElement('div'), card = document.createElement('div');
        outer.className = 'wc-fly';
        outer.style.cssText = 'left:' + x0 + 'px;top:' + y0 + 'px;width:' + size + 'px;height:' + size + 'px';
        card.className = 'wc-fly-img';
        if (src) { var im = document.createElement('img'); im.src = src.currentSrc || src.src; im.alt = ''; card.appendChild(im); }
        mid.appendChild(card); outer.appendChild(mid); document.body.appendChild(outer);
        var dur = 720;
        outer.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + dx + 'px)' }], { duration: dur, easing: 'cubic-bezier(.45, .05, .8, .5)', fill: 'forwards' });
        mid.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(' + dy + 'px)' }], { duration: dur, easing: 'cubic-bezier(.25, .6, .45, 1)', fill: 'forwards' });
        var last = card.animate([
          { transform: 'scale(1)', opacity: 1 },
          { transform: 'scale(1.08)', opacity: 1, offset: .14 },
          { transform: 'scale(.5)', opacity: 1, offset: .75 },
          { transform: 'scale(.18)', opacity: 0 }
        ], { duration: dur, easing: 'ease-in', fill: 'forwards' });
        var end = function () { if (outer.parentNode) outer.parentNode.removeChild(outer); done(); };
        last.onfinish = end;
        setTimeout(end, dur + 300);
      });
    };
    var hitIcon = function (icon, count) {
      setBubble(count, true);
      if (!icon) return;
      icon.classList.remove('wc-cart-hit');
      void icon.offsetWidth;
      icon.classList.add('wc-cart-hit');
      clearTimeout(icon.wcHit);
      icon.wcHit = setTimeout(function () { icon.classList.remove('wc-cart-hit'); }, 1000);
    };
    var twinsOf = function (vid) { return accBtns.filter(function (o) { return accVariant(o) === vid; }); };
    var addAcc = function (b, vid) {
      var twins = twinsOf(vid);
      twins.forEach(function (o) { o.disabled = true; setAdded(o, true); });
      pending++;
      var icon = cartIcon();
      var box = b.closest('.ws-acc-item, .ws-modal-panel');
      var flight = fly(box && box.querySelector('.ws-acc-img, .ws-modal-img'), icon);
      var items = b.dataset.items.split(',').filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
      var req = fetch(addUrl + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); });
      Promise.all([flight, req])
        .then(function (res) { readCart(res[1]); hitIcon(icon, res[1].item_count); })
        .catch(function () {})
        .then(function () { pending--; twins.forEach(function (o) { o.disabled = false; }); syncAcc(); });
    };
    var removeAcc = function (b, vid) {
      var pid = b.dataset.product;
      var boxes = pid ? Array.prototype.slice.call(document.querySelectorAll('[data-wc-addon][data-product="' + pid + '"]')).filter(function (cb) { return cb.checked; }) : [];
      var twins = twinsOf(vid);
      twins.forEach(function (o) { setAdded(o, false); });
      // l'option cochee dans la zone d'achat se decoche aussi (sa case renvoie wc:addons)
      boxes.forEach(function (cb) { if (!cb.disabled && !cb.hasAttribute('data-locked')) cb.click(); });
      if (!inCart[vid]) { syncAcc(); return; }
      twins.forEach(function (o) { o.disabled = true; });
      pending++;
      fetch(addUrl.replace(/\/add$/, '/change') + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ id: vid, quantity: 0 }) })
        .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
        .then(function (cart) { readCart(cart); setBubble(cart.item_count, false); })
        .catch(function () {})
        .then(function () { pending--; twins.forEach(function (o) { o.disabled = false; }); syncAcc(); });
    };
    accBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled || b.hasAttribute('data-included')) return;
        var vid = accVariant(b);
        if (b.hasAttribute('data-added')) removeAcc(b, vid); else addAcc(b, vid);
      });
    });
    document.addEventListener('wc:addons', function (e) {
      picked = ((e.detail && e.detail.products) || []).map(String);
      syncAcc();
    });
    if (accBtns.length) {
      readPicked();
      syncAcc();
      // le panier n'est lu qu'a l'approche des accessoires, et relu au retour arriere (page restauree du cache)
      var accZones = root.querySelectorAll('.ws-acc, .ws-floor');
      if (window.IntersectionObserver && accZones.length) {
        var ioA = new IntersectionObserver(function (es) {
          if (es.some(function (e) { return e.isIntersecting; })) { ioA.disconnect(); loadCart(); }
        }, { rootMargin: '600px 0px' });
        accZones.forEach(function (z) { ioA.observe(z); });
      } else { loadCart(); }
      window.addEventListener('pageshow', function (e) { if (e.persisted) loadCart(); });
    }

    if (isMobile()) {
      // le carrousel se construit a l'approche seulement : le clonage et la mesure coutent une mise en page complete
      var loops = root.querySelectorAll('[data-ws-loop]');
      var initLoop = function (t) { if (t.dataset.wsLooped) return; t.dataset.wsLooped = '1'; loopTrack(t); };
      if (window.IntersectionObserver) {
        var ioL = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { initLoop(e.target); ioL.unobserve(e.target); } }); }, { rootMargin: '300px 0px' });
        loops.forEach(function (t) { ioL.observe(t); });
      } else { loops.forEach(initLoop); }
    }

    var top = root.querySelector('[data-ws-top]');
    if (top) {
      top.addEventListener('click', function () {
        try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, 0); }
      });
      var onScroll = function () {
        if (window.pageYOffset > 700) top.setAttribute('data-on', ''); else top.removeAttribute('data-on');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Avant de percer : le visiteur choisit son mur, le verdict change
    var drill = root.querySelector('[data-ws-drill]');
    if (drill) {
      var wbtns = drill.querySelectorAll('[data-ws-wall]');
      var wpanels = drill.querySelectorAll('[data-ws-vpanel]');
      var pickWall = function (i) {
        wbtns.forEach(function (b) { b.setAttribute('aria-selected', b.dataset.wsWall === i ? 'true' : 'false'); });
        wpanels.forEach(function (p) { p.hidden = p.dataset.wsVpanel !== i; });
      };
      wbtns.forEach(function (b) { b.addEventListener('click', function () { pickWall(b.dataset.wsWall); }); });

      // « Dans le carton » : accordeon sur telephone, toujours ouvert sur ordinateur (CSS)
      var boxHead = drill.querySelector('[data-ws-boxtoggle]');
      if (boxHead) {
        boxHead.addEventListener('click', function () {
          boxHead.setAttribute('aria-expanded', boxHead.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
        });
      }
    }

    // Produits au sol : la tuile ouvre une fenetre, on ne quitte pas la page produit
    var modals = Array.prototype.slice.call(root.querySelectorAll('[data-ws-modal]'));
    if (modals.length) {
      var closeModals = function () {
        modals.forEach(function (m) { m.hidden = true; });
        document.documentElement.style.overflow = '';
      };
      // prechargement des photos voisines de celle affichee dans une fenetre (sinon chaque passage attend le reseau)
      var warmedM = {};
      var mwarm = function (url) { if (url && !warmedM[url]) { warmedM[url] = 1; var im = new Image(); im.src = url; } };
      var mwarmAround = function (m) {
        var ts = m.querySelectorAll('[data-ws-mimg]'), k = ts.length, at = 0;
        if (k < 2) return;
        ts.forEach(function (o, j) { if (o.getAttribute('aria-current') === 'true') at = j; });
        mwarm(ts[(at + 1) % k].dataset.wsMimg); mwarm(ts[(at - 1 + k) % k].dataset.wsMimg);
      };
      root.querySelectorAll('[data-ws-floor]').forEach(function (a) {
        // des qu'on approche la tuile, la grande photo de sa fenetre part (en lazy dans une fenetre cachee, elle
        // n'etait demandee qu'a l'ouverture et la fenetre s'ouvrait sur un cadre vide)
        var intent = function () {
          var m = root.querySelector('[data-ws-modal="' + a.dataset.wsFloor + '"]');
          var img = m && m.querySelector('.ws-modal-img img');
          if (img && img.loading === 'lazy') img.loading = 'eager';
        };
        a.addEventListener('pointerenter', intent, { passive: true });
        a.addEventListener('focus', intent);
        a.addEventListener('click', function (e) {
          var m = root.querySelector('[data-ws-modal="' + a.dataset.wsFloor + '"]');
          if (!m) return;
          e.preventDefault();
          closeModals();
          m.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          var x = m.querySelector('.ws-modal-x');
          if (x && x.focus) x.focus();
          mwarmAround(m);
        });
      });
      root.querySelectorAll('[data-ws-close]').forEach(function (b) { b.addEventListener('click', closeModals); });
      modals.forEach(function (m) {
        var big = m.querySelector('.ws-modal-img img');
        var thumbs = m.querySelectorAll('[data-ws-mimg]');
        thumbs.forEach(function (t) {
          t.addEventListener('click', function () {
            if (!big) return;
            big.src = t.dataset.wsMimg;
            big.srcset = '';
            thumbs.forEach(function (o) { o.removeAttribute('aria-current'); });
            t.setAttribute('aria-current', 'true');
            mwarmAround(m);
          });
        });
        // glisser le doigt sur la grande image passe a la suivante ou a la precedente
        var stage = m.querySelector('.ws-modal-img');
        if (stage && thumbs.length > 1) {
          var sx = null, sy = 0;
          stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
          stage.addEventListener('touchend', function (e) {
            if (sx === null) return;
            var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
            sx = null;
            if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
            var cur = 0;
            thumbs.forEach(function (o, k) { if (o.getAttribute('aria-current') === 'true') cur = k; });
            thumbs[(cur + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length].click();
          }, { passive: true });
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.key === 'Esc') closeModals(); });
    }

    var ex = root.querySelector('[data-ws-explorer]');
    if (ex) {
      var tabs = ex.querySelectorAll('[data-ws-tab]'), markers = ex.querySelectorAll('[data-ws-marker]'), callouts = ex.querySelectorAll('[data-ws-callout]'), ring = ex.querySelector('[data-ws-ring]');
      var vids = ex.querySelectorAll('[data-ws-vid]');
      // le poster et le chargement n'arrivent qu'a l'approche ou au premier affichage (preload="none" et data-poster dans la section)
      var armVid = function (box) {
        var v = box.querySelector('video'); if (!v) return null;
        if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
        if (v.preload === 'none') { lowHls(v); v.preload = 'metadata'; }
        return v;
      };
      var playVid = function (box, on) {
        var v = on ? armVid(box) : box.querySelector('video'); if (!v) return;
        if (on) { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (v.pause) { v.pause(); }
      };
      var select = function (i) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.wsTab === i ? 'true' : 'false'); });
        markers.forEach(function (m) { var on = m.dataset.wsMarker === i; m.setAttribute('aria-selected', on ? 'true' : 'false'); if (on && ring) { ring.style.left = m.style.left; ring.style.top = m.style.top; } });
        callouts.forEach(function (c) { c.hidden = c.dataset.wsCallout !== i; });
        vids.forEach(function (b) { var on = b.dataset.wsVid === i; b.hidden = !on; playVid(b, on); });
      };
      tabs.forEach(function (t) { t.addEventListener('click', function () { select(t.dataset.wsTab); }); });
      markers.forEach(function (m) { m.addEventListener('click', function () { select(m.dataset.wsMarker); }); });
      if (vids.length) {
        var first = vids[0];
        if (window.IntersectionObserver) {
          // poster pose 300 px avant l'arrivee a l'ecran, lecture a 40 % visible
          var io3 = new IntersectionObserver(function (es) {
            es.forEach(function (e) { if (e.isIntersecting) { armVid(e.target); io3.unobserve(e.target); } });
          }, { rootMargin: '300px 0px' });
          var io2 = new IntersectionObserver(function (es) {
            es.forEach(function (e) { if (e.isIntersecting) { playVid(e.target, true); io2.unobserve(e.target); } });
          }, { threshold: 0.4 });
          io3.observe(first); io2.observe(first);
        } else { playVid(first, true); }
      }
    }

    var calc = root.querySelector('[data-ws-calc]');
    if (calc) {
      var range = calc.querySelector('[data-ws-range]'), out = calc.querySelector('[data-ws-out]'), gym = calc.querySelector('[data-ws-gym]');
      var pay = calc.querySelector('[data-ws-pay]');
      var price = (Number(calc.dataset.price) || 0) / 100;
      var months = Number(calc.dataset.months) || 36;
      // separateur de milliers a la main : la premiere initialisation de toLocaleString('fr-FR') coute ~100 ms sur telephone.
      // Espace insecable normale : l'Anton servie par Shopify n'a pas l'espace fine (U+202F), « 1 044 € » s'affichait « 1044 € »
      var fmt = function (n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0') + '\u00A0€'; };
      var upd = function () {
        var v = Number(range.value), pct = (v - range.min) / (range.max - range.min) * 100;
        range.style.setProperty('--pct', pct + '%');
        out.textContent = v + ' € / mois';
        gym.textContent = fmt(v * months);
        if (pay && price > 0 && v > 0) pay.textContent = (pay.dataset.tpl || '').replace('{n}', Math.max(1, Math.ceil(price / v)));
      };
      range.addEventListener('input', upd); upd();
    }

    var rv = root.querySelector('[data-ws-reviews]');
    if (rv) {
      var cards = rv.querySelectorAll('[data-ws-rev]'), pills = rv.querySelectorAll('[data-ws-filter]'), more = rv.querySelector('[data-ws-more]');
      var expanded = false, filter = 'all';
      var apply = function () {
        var shown = 0;
        cards.forEach(function (c) {
          var ok = filter === 'all' || c.dataset.stars === filter;
          if (ok && !expanded && shown >= 6) ok = false;
          c.hidden = !ok; if (ok) shown++;
        });
        if (more) more.style.display = expanded ? 'none' : '';
      };
      pills.forEach(function (p) { p.addEventListener('click', function () { filter = p.dataset.wsFilter; pills.forEach(function (o) { o.setAttribute('aria-pressed', o === p ? 'true' : 'false'); }); apply(); }); });
      if (more) more.addEventListener('click', function () { expanded = true; apply(); });
      apply();

      // Visionneuse façon Loox : la carte s'ouvre en grand, on passe d'un avis à l'autre
      // (fermeture par la croix, le fond ou Echap : c'est closeModals des produits au sol qui s'en charge)
      var lb = rv.querySelector('[data-ws-modal="rev"]');
      if (lb) {
        var lbPanel = lb.querySelector('[data-ws-rlb]'), lbImg = lb.querySelector('[data-ws-rlb-img]'), lbStars = lb.querySelector('[data-ws-rlb-stars]');
        var lbT = lb.querySelector('[data-ws-rlb-t]'), lbX = lb.querySelector('[data-ws-rlb-x]'), lbA = lb.querySelector('[data-ws-rlb-a]'), lbCount = lb.querySelector('[data-ws-rlb-count]');
        var lbSteps = lb.querySelectorAll('[data-ws-rlb-step]');
        var lbList = [], lbAt = 0, lbFrom = null;
        var txt = function (c, sel) { var n = c.querySelector(sel); return n ? n.textContent.trim() : ''; };
        var preload = function (c) { if (c && c.dataset.full) { var im = new Image(); im.src = c.dataset.full; } };
        var show = function (i) {
          var n = lbList.length; if (!n) return;
          lbAt = (i + n) % n;
          var c = lbList[lbAt], full = c.dataset.full || '';
          lbPanel.classList.toggle('is-text', !full);
          if (full) { lbImg.src = full; lbImg.alt = txt(c, '.ws-rev-a'); } else { lbImg.removeAttribute('src'); lbImg.alt = ''; }
          lbStars.dataset.n = c.dataset.stars;
          lbT.textContent = txt(c, '.ws-rev-t');
          lbX.textContent = txt(c, '.ws-p');
          lbA.textContent = txt(c, '.ws-rev-a');
          lbCount.textContent = (lbAt + 1) + ' / ' + n;
          lbSteps.forEach(function (b) { b.style.visibility = n < 2 ? 'hidden' : ''; });
          if (n > 1) { preload(lbList[(lbAt + 1) % n]); preload(lbList[(lbAt - 1 + n) % n]); }
        };
        var openLb = function (c) {
          if (window.Shopify && window.Shopify.designMode) return;
          lbList = Array.prototype.filter.call(cards, function (o) { return filter === 'all' || o.dataset.stars === filter; });
          lbFrom = c;
          show(Math.max(0, lbList.indexOf(c)));
          lb.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          var x = lb.querySelector('.ws-modal-x'); if (x && x.focus) x.focus();
        };
        cards.forEach(function (c) {
          c.addEventListener('click', function () { openLb(c); });
          c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLb(c); } });
        });
        lbSteps.forEach(function (b) { b.addEventListener('click', function () { show(lbAt + Number(b.dataset.wsRlbStep)); }); });
        document.addEventListener('keydown', function (e) {
          if (lb.hidden) return;
          if (e.key === 'ArrowLeft') show(lbAt - 1);
          else if (e.key === 'ArrowRight') show(lbAt + 1);
        });
        // on rend le focus à la carte d'origine quand la fenêtre se referme
        if (window.MutationObserver) {
          new MutationObserver(function () {
            if (lb.hidden && lbFrom) { try { lbFrom.focus({ preventScroll: true }); } catch (err) {} lbFrom = null; }
          }).observe(lb, { attributes: true, attributeFilter: ['hidden'] });
        }
        // glisser du doigt sur téléphone
        var tx = null, ty = null;
        lbPanel.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
        lbPanel.addEventListener('touchend', function (e) {
          if (tx === null) return;
          var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty; tx = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(lbAt + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
    }

    // Cartes de version du CTA final : sélectionnent la variante dans la zone d'achat
    var picks = root.querySelectorAll('[data-wc-pick]');
    picks.forEach(function (b) {
      b.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('wc:variant-select', { detail: { id: b.dataset.wcPick, scroll: false } }));
      });
    });
    document.addEventListener('wc:variant', function (e) {
      picks.forEach(function (b) { if (String(b.dataset.wcPick) === String(e.detail.id)) b.setAttribute('aria-current', 'page'); else b.removeAttribute('aria-current'); });
      // image de l'appel final : celle de la version choisie (l'autre est masquee en CSS), avec un court fondu
      var ver = e.detail.pro ? 'pro' : 'station';
      if (root.getAttribute('data-version') !== ver) {
        root.setAttribute('data-version', ver);
        var ctaImg = root.querySelector('.ws-cta-v--' + ver);
        if (ctaImg && ctaImg.animate) ctaImg.animate([{ opacity: 0.3 }, { opacity: 1 }], { duration: 300, easing: 'ease-out' });
      }
      root.querySelectorAll('[data-ws-follow]').forEach(function (b) { b.dataset.items = String(e.detail.id); });
      // ligne sous le bouton des avis : nom et prix de la version choisie
      root.querySelectorAll('[data-ws-vname]').forEach(function (s) { s.hidden = String(s.dataset.wsVname) !== String(e.detail.id); });
    });
  };

  // Videos HLS de Shopify (reels, En mouvement) : la liste maitresse propose 480p, 720p et 1080p et le lecteur monte
  // a la plus haute que le reseau permet, meme sur une tuile de 140 px (9 Mo pour deux reels, mesure du 11/09).
  // Apres le chargement, fitHls lit cette liste (moins d'1 Ko, en cache un an) et note la plus petite variante assez
  // nette pour la taille affichee ; lowHls la pose au moment ou la video doit se charger (amorcage), pas avant :
  // le lecteur HLS natif de Chrome ignore preload="none" apres un load(), il chargerait des videos que personne ne voit.
  function fitHls(v) {
    var s = v.querySelector('source[type="application/x-mpegURL"]');
    if (!s || v.dataset.hlsFit || !v.canPlayType || !v.canPlayType('application/vnd.apple.mpegurl')) return;
    v.dataset.hlsFit = '1';
    var master = s.src;
    // largeur affichee ; pour un onglet masque (largeur nulle), celle du premier parent visible
    var box = v, w = 0;
    while (box && !(w = box.clientWidth)) box = box.parentElement;
    var need = (w || 300) * Math.min(window.devicePixelRatio || 1, 2) * 0.9;
    fetch(master).then(function (r) { return r.ok ? r.text() : ''; }).then(function (txt) {
      var lines = txt.split(/\r?\n/), fit = null, top = null;
      for (var i = 0; i < lines.length - 1; i++) {
        var m = /^#EXT-X-STREAM-INF:.*RESOLUTION=(\d+)x\d+/.exec(lines[i]);
        if (!m || !lines[i + 1].trim()) continue;
        var c = { w: +m[1], uri: lines[i + 1].trim() };
        if (!top || c.w > top.w) top = c;
        if (c.w >= need && (!fit || c.w < fit.w)) fit = c;
      }
      var pick = fit || top;
      if (pick) v.dataset.hlsLow = new URL(pick.uri, master).href;
    }).catch(function () {});
  }
  // a appeler juste avant de passer preload a 'metadata' ou de lancer la lecture
  function lowHls(v) {
    if (!v || !v.dataset.hlsLow || v.dataset.hlsOn || v.readyState > 0 || v.networkState === 2 || !v.paused) return;
    var s = v.querySelector('source[type="application/x-mpegURL"]');
    if (!s) return;
    v.dataset.hlsOn = '1';
    s.src = v.dataset.hlsLow;
    v.load();
  }

  function init() {
    // la zone d'achat d'abord (c'est elle qu'on touche en premier), le recit dans la tache suivante :
    // le navigateur peut repondre a un tap entre les deux au lieu d'enchainer les deux initialisations.
    // Le minuteur du recit est pose AVANT d'initialiser la zone d'achat, sinon il passerait apres l'annonce
    // de la version ouverte (elle aussi differee) et le recit la raterait.
    var stories = document.querySelectorAll('[data-wc-story]');
    if (stories.length) setTimeout(function () { stories.forEach(function (r) { window.WallcoreStory(r); }); }, 0);
    document.querySelectorAll('[data-wc-product]').forEach(function (r) { window.WallcoreProduct(r); });
    var idle = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(function () { document.querySelectorAll('video').forEach(fitHls); }); };
    if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();